<script>
  import { getStr } from '../../../../common/util';
  import StarRating from '../WriteReview/StarRating.svelte';

  export let rating;
  export let number;
  export let barPercent;
</script>

<section class="individual-rate-row-container">
  <span class="label">{rating} {getStr('extra.pdp.review.star')}</span>
  <span class="stars">
    <StarRating {rating} readOnly />
  </span>
  <span style:--percent={barPercent + '%'} class="bar"> </span>
  <span class="number">{number}</span>
</section>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .individual-rate-row-container {
    display: flex;
    align-items: center;
    gap: 8px;

    .label,
    .number {
      font-weight: 700;
      font-size: 12px;
      line-height: 14px;
      @include desktop-extraSmall-width() {
        font-size: 11px;
        line-height: 13px;
      }
    }
    .bar {
      width: 120px;
      height: 6px;
      background-color: $secondary-gray-02;
      border-radius: 20px;
      position: relative;

      &::after {
        position: absolute;
        content: '';
        inset: 0;
        background-color: $neutral-dark-04;
        border-radius: 20px;
        width: var(--percent);
      }
    }
    .number {
      font-weight: 500;
    }
    .stars {
      :global {
        .star-rating-container {
          gap: 4px;

          svg {
            width: 20px;
            height: 20px;
            @include desktop-extraSmall-width() {
              width: 16px;
              height: 16px;
            }
          }
        }
      }
    }
  }
</style>
